import React from 'react'
import Lottie from "react-lottie";
import notask from './notask.json'

function Notask(props) {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: notask,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
    return (
        <div>
            <div className='Notask'>
            <h2>{props.error}</h2>
           <Lottie options={defaultOptions} width={150} height={150} isClickToPauseDisabled />
            </div>
        </div>
    )
}

export default Notask
